import { Directive, Injector, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[modal-button]' })
export class ModalButtonDirective {
    @Input() visable = true;
    constructor(private injector: Injector, private el: ElementRef) { }

    setDisabled(disable: boolean) {
        this.el.nativeElement.disabled = disable;
    }

    show() {
        this.visable = true;
    }

    hide() {
        this.visable = false;
    }
}
